import { Paper } from "@mui/material";
import styled from "styled-components";
import { theme } from "styles/mui-config";

export const Wrapper = styled.div`
  width: ${(props) => (props.inModal ? "100%" : "100vw")};
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.5);
  position: fixed;
  left: 0;
  top: 0;
  z-index: 2000;
  & * {
    display: flex;
    justify-content: center;
    z-index: 1;
  }
`;

export const StyledPaper = styled(Paper)`
  width: 295px;
  height: 205px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  flex-direction: column;
  border-radius: 10px !important;
  padding: 25px;
  box-shadow: 0 1px 1px 0 #ececec, 0 1px 5px 0 #ececec !important;

  & pre {
    font-family: "Avini";
    color: ${theme.palette.primary.main};
    font-size: 33px;
    margin-top: -5px;
    margin-right: 6px;
  }

  & img {
    width: 150px !important;
    height: 55px !important;
    @media (max-width: 500px) {
      width: 140px !important;
      height: 50px !important;
    }
    @media (max-width: 400px) {
      width: 120px !important;
      height: 45px !important;
    }
  }

  @media (max-width: 500px) {
    width: 300px;
    height: 200px;
  }
  @media (max-width: 400px) {
    width: 260px;
    height: 200px;
  }
`;
